module.exports = __webpack_public_path__ + "ecd4ba83ec87dd6d028a54d58ac6a367.png";